import EditFilterModal, {
	EditFilterModalProps,
	IFormValuesEditFilters
} from './EditFilterModal';

export type { EditFilterModalProps, IFormValuesEditFilters };
export default EditFilterModal;
